// Remember to create a backup copy of this file before you start editing.
window.BBBSettings = {
    playerJumpSpeed: 550,   // How fast the player moves when they jump
    gravity: 700,           // How strong gravity is
    speed: 350,             // How fast the game scrolls
    minBearTime: 0.5,         // The minimum time between bears
    maxBearTime: 3,         // The maximum time between bears
    minBearScale: 0.25,     // The smallest a bear can be, 1 is equivalent to 202px tall
    maxBearScale: 0.8,      // The biggest a bear can be, 1 is equivalent to 202px tall
    minBriefTime: .1,        // The minimum time between briefs
    maxBriefTime: .5,        // The maximum time between briefs
    minBriefHeight: 0.2,    // 0.5 is halfway up the screen.
    maxBriefHeight: 0.9,    // 1.0 is the top of the screen.
    briefSparkleTime: 0.5,  // How long each sparkle lasts
    scorePerSecond: 0,      // Number of points the player get per second
    scorePerBrief: 1,      // Number of points the player gets for collecting a brief
    scoreToWin: 50,         // Number of points to trigger the win screen
  	win: {
        Header: "WOW",    // Header to display when won
        Body: "You must be the one that was foretold. A great leader who will finally break us out of the matrix. Use the code 'CHOSENONE' at checkout to take an additional 20% off any pair of underwear.",
        Button: "Replay"
    },
    lose: {
        Header: "Game Over",    // Header to display when lose
        Body: "Its not time to cry yet, wait until you are in the car driving home from work like I do.",
        Button: "Try Again"
    },
    startButton: "Play now!"
};